import { render } from "./MenuFile.vue?vue&type=template&id=3436fa9a"
import script from "./MenuFile.vue?vue&type=script&lang=js"
export * from "./MenuFile.vue?vue&type=script&lang=js"

import "./MenuFile.vue?vue&type=style&index=0&id=3436fa9a&lang=css"
script.render = render

export default script